const BesoinReducer =  (state = [], action) => {
      return state
}

export default BesoinReducer;
